<div class="modal-header">
  <h4 class="modal-title" id="myModalLabel1">Inclusão - Exceção de Ponto</h4>
  <button type="button" (click)="onDismiss()" class="close" aria-label="Close">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body" tabindex="0" ngbAutofocus>
  <div class="card-body">
    <form class="form-horizontal" [formGroup]="form" #frm>
      <div class="row">
        <div [ngClass]="{'col-12': !showEntryDepartureFields, 'col-6': showEntryDepartureFields}">
          <div class="form-group">
            <label class="form-control-label"  for="date">Data</label>
            <input type="date" id="date" formControlName="date" required (change)="timeShiftOrDateChange()" class="form-control" />
            <app-error-msg [control]="form.controls['date']" [label]="'date'"> </app-error-msg>
          </div>
        </div>
        <div [ngClass]="{'col-12': !showEntryDepartureFields, 'col-6': showEntryDepartureFields}">
          <div class="form-group">
            <label class="form-control-label"  for="type">Tipo</label>
            <select formControlName="type" placeholder="Selecionar" (change)="typeChange()" class="custom-select">
              <option *ngFor="let option of typeOptions" [value]="option.value">{{option.label}}</option>
            </select>
            <app-error-msg [control]="form.controls['type']" [label]="'type'"> </app-error-msg>
          </div>
        </div>
        <div *ngIf="showEntryDepartureFields" class="col-12">
          <div class="form-group">
            <label class="form-control-label"for="timeShiftId">Turno</label>
            <ng-select [compareWith]="compareValues" formControlName="timeShiftId" placeholder="Selecionar"
              (change)="timeShiftOrDateChange()">
              <ng-option *ngFor="let option of timeShiftsOptions" [value]="option.value">{{option.label}}</ng-option>
            </ng-select>
            <app-error-msg [control]="form.controls['timeShiftId']" [label]="'timeShiftId'"> </app-error-msg>
          </div>
        </div>
        <div *ngIf="showEntryDepartureFields" class="col-6">
          <div class="form-group">
            <label class="form-control-label"for="entry1">1° Entrada</label>
            <input [attr.disabled]="true" type="time" formControlName="entry1" required class="form-control" />
            <app-error-msg [control]="form.controls['entry1']" [label]="'entry1'"> </app-error-msg>
          </div>
        </div>
        <div *ngIf="showEntryDepartureFields" class="col-6">
          <div class="form-group">
            <label class="form-control-label"for="departure1">1° Saída</label>
            <input [attr.disabled]="true" type="time" formControlName="departure1" required class="form-control" />
            <app-error-msg [control]="form.controls['departure1']" [label]="'departure1'"> </app-error-msg>
          </div>
        </div>
        <div *ngIf="showEntryDepartureFields" class="col-6">
          <div class="form-group">
            <label class="form-control-label"for="entry2">2° Entrada</label>
            <input [attr.disabled]="true" type="time" formControlName="entry2" required class="form-control" />
            <app-error-msg [control]="form.controls['entry2']" [label]="'entry2'"> </app-error-msg>
          </div>
        </div>
        <div *ngIf="showEntryDepartureFields" class="col-6">
          <div class="form-group">
            <label class="form-control-label"for="departure2">2° Saída</label>
            <input [attr.disabled]="true" type="time" formControlName="departure2" required class="form-control" />
            <app-error-msg [control]="form.controls['departure2']" [label]="'departure2'"> </app-error-msg>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-outline-danger" (click)="onDismiss()" rippleEffect>
    Cancelar
  </button>
  <button type="button" [disabled]="isLoading" (click)="handleSubmit()" #btnConfirm class="btn btn-success" rippleEffect>
    Confirmar <span *ngIf="isLoading" class="spinner-border spinner-border-sm"></span>
  </button>
</div>